import modalStyles from "../Modals/modals.module.scss";
import ReactDOM from "react-dom";

export default function WorkersModal({ isOpen, onClose, user }) {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className={modalStyles.modal_overlay}>
      <div className={modalStyles.modal_content}>
        <div className={modalStyles.container}></div>
        {user.first_name} {user.last_name}
      </div>
    </div>,
    document.getElementById("modal-root")
  );
}
